<template>
	<div class="AppStockCountCalendar">
		<div class="text-right">
			<a>Export</a>
		</div>
		<div class="table-parent">
			<table class="tableMain">
				<thead>
					<tr>
						<th>Category</th>
						<th>Daily</th>
						<th>Weekly</th>
						<th>Monthly</th>
					</tr>
				</thead>
				<tbody>
					<tr>
						<td>
							<button class="category-btn">
								Category 1
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<button class="category-btn">
								Category 2
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<button class="category-btn">
								Category 3
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<button class="category-btn">
								Category 4
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<button class="category-btn">
								Category 5
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
					<tr>
						<td>
							<button class="category-btn">
								Category 6
							</button>
						</td>
						<td><input type="radio" />Daily</td>

						<td>
							<el-select placeholder="Day of Week">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>

						<td>
							<el-select placeholder="Day of Month">
								<el-option v-for="(item, index) in 5" :value="item" />
							</el-select>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="text-right">
			<a>Save Calendar</a>
		</div>
	</div>
</template>

<script>
export default {
	name: "AppStockCountCalendar",
	mixins: [],
	props: [],
	data() {
		return {};
	},
	methods: {}
};
</script>

<style lang="scss" scoped>
@import "./AppStockCountCalendar.scss";
</style>
